module.exports = __webpack_public_path__ + "static/compose-6eb6c51e67a51be166c9c4125a56fd0d.png";